<template>
  <div>
    <div class="room-number" v-if="numRoom > 0">{{ numRoom + 1 }}部屋目</div>

    <!-- PC表示 -->
    <template v-if="innerWidth > 680">
      <table class="table-common">
        <tr>
          <th class="p-4 w-1/5"></th>
          <th class="main_col w-1/5">会員 (補助対象) 人数</th>
          <th class="main_col w-1/5">宿泊料金<br>(1泊1名あたり)</th>
          <th class="main_col w-1/5">ビジター (補助対象外) 人数</th>
          <th class="main_col w-1/5">宿泊料金<br>(1泊1名あたり)</th>
        </tr>

        <!-- 大人(中学生以上) -->
        <tr>
          <td class="main_col font-bold">大人(中学生以上)</td>
          <td>
            <a-select style="width: 85px;" v-model.number="dataBinding.member.man">
              <a-select-option
                :value="el.value"
                v-for="(el, index) in memberAdultOptions"
                :key="`room-${index}`"
              >
                {{ el.label }}
              </a-select-option>
            </a-select>
            <span class="ml-2">名 <span class="text-primary">*</span></span>
          </td>
          <td>
            <div>
              <a-input style="width: 85px;" 
                default-value="0"
                :maxLength="13"
                placeholder=""
                @change="onChangeTextInput($event, 1)" 
                v-model.number.trim="dataBinding.member.manPrice"></a-input>
              <span class="ml-2">円<span class="text-primary">*</span></span>
            </div>
          </td>
          <td>
            <a-select style="width: 85px;"  v-model.number="dataBinding.visitors.man">
              <a-select-option
                :value="el.value"
                v-for="(el, index) in visitorAdultOptions"
                :key="`room-${index}`"
              >
                {{ el.label }}
              </a-select-option>
            </a-select>
            <span class="ml-2">名</span>
          </td>
          <td>
            <div>
              <a-input style="width: 85px;"
                default-value="0"
                :maxLength="13"
                placeholder=""
                @change="onChangeTextInput($event, 4)" 
                v-model.number="dataBinding.visitors.visitorManPrice"></a-input>
              <span class="ml-2">円</span>
            </div>
          </td>
        </tr>

        <!-- 有料の小学生 -->
        <tr>
          <td class="font-bold main_col">有料の小学生</td>
          <td>                    
            <a-select style="width: 85px;"  v-model.number="dataBinding.children.childrenMember10">
              <a-select-option
                :value="el.value"
                v-for="(el, index) in memberAdultOptions"
                :key="`room-${index}`"
              >
                {{ el.label }}
              </a-select-option>
            </a-select>
            <span class="ml-2">名</span></td>
          <td>
            <div>
              <a-input style="width: 85px;"
                default-value="0"
                :maxLength="13"
                placeholder=""
                @change="onChangeTextInput($event, 2)" 
                v-model.number.trim="dataBinding.children.childrenMember10Price"></a-input>
              <span class="ml-2">円</span>
            </div> 
          </td>
          <td>
            <a-select style="width: 85px;"  v-model.number="dataBinding.children.childrenVisitor10">
              <a-select-option
                :value="el.value"
                v-for="(el, index) in visitorAdultOptions"
                :key="`room-${index}`"
              >
                {{ el.label }}
              </a-select-option>
            </a-select>
            <span class="ml-2">名</span>
          </td>
          <td>
            <div>
              <a-input style="width: 85px;"
                default-value="0"
                :maxLength="13"
                placeholder=""
                @change="onChangeTextInput($event, 5)" 
                v-model.number="dataBinding.children.childrenVisitor10Price"></a-input>
              <span class="ml-2">円</span>
            </div> 
          </td>
        </tr>

        <!-- 有料の幼児 ※弊社補助対象外 -->
        <tr>
          <td class="font-bold main_col">有料の幼児<br>※弊社補助対象外</td>
          <td>                    
            <a-select style="width: 85px;"  v-model.number="dataBinding.children.childrenMember15">
              <a-select-option
                :value="el.value"
                v-for="(el, index) in memberAdultOptions"
                :key="`room-${index}`"
              >
                {{ el.label }}
              </a-select-option>
            </a-select>
            <span class="ml-2">名</span> 
          </td>
          <td>                    
            <div>
              <a-input style="width: 85px;"
                default-value="0"
                :maxLength="13"
                placeholder=""
                @change="onChangeTextInput($event, 3)" 
                v-model.number.trim="dataBinding.children.childrenMember15Price"></a-input>
              <span class="ml-2">円</span>
            </div>  
          </td>
          <td></td>
          <td></td>
        </tr>
      </table>
    </template>



    <!-- SP表示 -->
    <template v-if="innerWidth <= 680">
      <div>
        <!-- 大人(中学生以上) -->
        <table class="table-auto w-full mb-4">
          <!-- ヘッダー -->
          <thead class="table_head">
            <tr>
              <th>大人(中学生以上)</th>
            </tr>
          </thead>

          <!-- ボディー -->
          <tbody>
            <!-- 会員 (補助対象) 人数 -->
            <tr>
              <td class="table_item table_item__first">
                <p>会員 (補助対象) 人数</p>
                <div class="table_item_cont">
                  <div class="table_item_select_dummy">
                    <select
                      v-model.number="dataBinding.member.man"
                      class="table_item_select"
                    >
                      <option
                        :value="el.value"
                        v-for="(el, index) in memberAdultOptions"
                        :key="`room-${index}`"
                      >
                        {{ el.label }}
                      </option>
                    </select>
                  </div>
                  <span>名</span>
                </div>
              </td>
            </tr>

            <!-- 宿泊料金(1泊1名あたり) -->
            <tr>
              <td class="table_item">
                <p>宿泊料金(1泊1名あたり)</p>
                <div class="table_item_cont">
                  <input
                    class="table_item_input"
                    type="number"
                    value="0"
                    maxlength="13"
                    placeholder="0"
                    @change="onChangeTextInput($event, 1)"
                    oninput="if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength)"
                    v-model.number.trim="dataBinding.member.manPrice"
                  />
                  <span>円</span>
                </div>
              </td>
            </tr>

            <!-- ビジター (補助対象外) 人数 -->
            <tr>
              <td class="table_item">
                <p>ビジター (補助対象外) 人数</p>
                <div class="table_item_cont">
                  <div class="table_item_select_dummy">
                    <select 
                      v-model.number="dataBinding.visitors.man"
                      class="table_item_select"
                    >
                      <option
                        :value="el.value"
                        v-for="(el, index) in visitorAdultOptions"
                        :key="`room-${index}`"
                      >
                        {{ el.label }}
                      </option>
                    </select>
                  </div>
                  <span>名</span>
                </div>

              </td>
            </tr>

            <!-- 宿泊料金(1泊1名あたり) -->
            <tr>
              <td class="table_item">
                <p>宿泊料金(1泊1名あたり)</p>
                <div class="table_item_cont">
                  <input 
                    class="table_item_input" 
                    type="number"
                    value="0"
                    maxlength="13"
                    placeholder="0"
                    @change="onChangeTextInput($event, 4)"
                    oninput="if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength)"
                    v-model.number.trim="dataBinding.visitors.visitorManPrice"
                  />
                  <span>円</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- 有料の小学生 -->
        <table class="table-auto w-full mb-4">
          <!-- ヘッダー -->
          <thead class="table_head">
            <tr>
              <th>有料の小学生</th>
            </tr>
          </thead>

          <!-- ボディー -->
          <tbody>
            <!-- 会員 (補助対象) 人数 -->
            <tr>
              <td class="table_item table_item__first">
                <p>会員 (補助対象) 人数</p>
                <div class="table_item_cont">
                  <div class="table_item_select_dummy">
                    <select
                      v-model.number="dataBinding.children.childrenMember10"
                      class="table_item_select"
                    >
                      <option
                        :value="el.value"
                        v-for="(el, index) in memberAdultOptions"
                        :key="`room-${index}`"
                      >
                        {{ el.label }}
                      </option>
                    </select>
                  </div>
                  <span>名</span>
                </div>
              </td>
            </tr>

            <!-- 宿泊料金(1泊1名あたり) -->
            <tr>
              <td class="table_item">
                <p>宿泊料金(1泊1名あたり)</p>
                <div class="table_item_cont">
                  <input
                    class="table_item_input"
                    type="number"
                    value="0"
                    maxlength="13"
                    placeholder="0"
                    @change="onChangeTextInput($event, 2)" 
                    oninput="if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength)"
                    v-model.number.trim="dataBinding.children.childrenMember10Price"
                  />
                  <span>円</span>
                </div>
              </td>
            </tr>

            <!-- ビジター (補助対象外) 人数 -->
            <tr>
              <td class="table_item">
                <p>ビジター (補助対象外) 人数</p>
                <div class="table_item_cont">
                  <div class="table_item_select_dummy">
                    <select 
                      v-model.number="dataBinding.children.childrenVisitor10"
                      class="table_item_select"
                    >
                      <option
                        :value="el.value"
                        v-for="(el, index) in visitorAdultOptions"
                        :key="`room-${index}`"
                      >
                        {{ el.label }}
                      </option>
                    </select>
                  </div>
                  <span>名</span>
                </div>

              </td>
            </tr>

            <!-- 宿泊料金(1泊1名あたり) -->
            <tr>
              <td class="table_item">
                <p>宿泊料金(1泊1名あたり)</p>
                <div class="table_item_cont">
                  <input 
                    class="table_item_input" 
                    type="number"
                    value="0"
                    maxlength="13"
                    placeholder="0"
                    @change="onChangeTextInput($event, 5)" 
                    oninput="if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength)"
                    v-model.number="dataBinding.children.childrenVisitor10Price"
                  />
                  <span>円</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- 有料の幼児 ※弊社補助対象外 -->
        <table class="table-auto w-full">
          <!-- ヘッダー -->
          <thead class="table_head">
            <tr>
              <th>有料の幼児 ※弊社補助対象外</th>
            </tr>
          </thead>

          <!-- ボディー -->
          <tbody>
            <!-- 会員 (補助対象) 人数 -->
            <tr>
              <td class="table_item table_item__first">
                <p>会員 (補助対象) 人数</p>
                <div class="table_item_cont">
                  <div class="table_item_select_dummy">
                    <select
                      v-model.number="dataBinding.children.childrenMember15"
                      class="table_item_select"
                    >
                      <option
                        :value="el.value"
                        v-for="(el, index) in memberAdultOptions"
                        :key="`room-${index}`"
                      >
                        {{ el.label }}
                      </option>
                    </select>
                  </div>
                  <span>名</span>
                </div>
              </td>
            </tr>

            <!-- 宿泊料金(1泊1名あたり) -->
            <tr>
              <td class="table_item">
                <p>宿泊料金(1泊1名あたり)</p>
                <div class="table_item_cont">
                  <input
                    class="table_item_input"
                    type="number"
                    value="0"
                    maxlength="13"
                    placeholder="0"
                    @change="onChangeTextInput($event, 3)" 
                    oninput="if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength)"
                    v-model.number.trim="dataBinding.children.childrenMember15Price"
                  />
                  <span>円</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>

      <div class="text-right hidden">
        <span
          class="ml-4 font-bold text-primary"
          v-for="(errorMsg, idx) in roomErrors"
          :key="`room-${idx}`"
        >
          {{ errorMsg }}
        </span>
      </div>
      <div class="text-right">
        <span v-for="(errorOneObj, idx) in arrCheckPriceLessThanOne"
          :key="`room-${idx}`"
          class="ml-4 font-bold text-primary block"
          v-show="errorOneObj && +errorOneObj.rooms">
         <span v-show="+errorOneObj.rooms -1 === numRoom">{{errorOneObj.rooms}}部屋目の有料の{{errorOneObj.label}}宿泊料金（1泊1名あたり）を入力してください。</span>
        </span>
        <span v-for="(errorPriceObj, idx) in arrInputPriceErrorMsg"
          :key="`room-price-${idx}`"
          class="ml-4 font-bold text-primary block"
          v-show="errorPriceObj && +errorPriceObj.rooms && errorPriceObj.price">
         <span v-show="+errorPriceObj.rooms -1 === numRoom && errorPriceObj.price > 0">{{errorPriceObj.rooms}}部屋目の{{errorPriceObj.option}}会員の宿泊代が補助金を下回っています。会員の宿泊代は補助金以上の金額を入力してください。</span>
        </span>
        <span v-for="(errorPeopleObj, idx) in arrCheckAmountPeopleInputErrMsg"
          :key="`room-price-${idx}`"
          class="ml-4 font-bold text-primary block"
          v-show="errorPeopleObj && +errorPeopleObj.rooms">
         <span v-show="+errorPeopleObj.rooms -1 === numRoom">{{errorPeopleObj.rooms}}部屋目の有料の{{errorPeopleObj.label}}数を入力してください。</span>
        </span>
      </div>
      <div class="py-3 text-info">
        ※会員(補助対象)の方とは、二親等内親族の方までとなります。(一部ご契約内容により異なる団体様もございます。)<br>
        ※１室あたり(ルームチャージ)の料金は、1室料金をご利用人数で均等割りした料金をご入力ください。<br>
        ※有料の幼児は、寝具料金や食事料金などが発生する場合のみご入力ください<br>
        ※会員大人は最低1名以上選択してください。また、会員大人を含め、2名以上で入力してください。有料の幼児は人数カウント対象となりません。
      </div>
  </div>
</template>

<script>
import _ from 'lodash'
import func_utils from '@/mixins/func_utils'
import plan_utils from '@/mixins/plan_utils'

export default {
  mixins: [func_utils, plan_utils],
  props: ['value', 'numRoom', 'roomErrors', 'arrInputPriceErrorMsg', 'arrCheckPriceLessThanOne', 'arrCheckAmountPeopleInputErrMsg'],
  data() {
    return {
      showPopoverMember: false,
      showPopoverVisitor: false,
      stayDayDetails: [],
      dataBinding: {
        roomPrice: null,
        stayDay: null,
        adultPrice: 0,
        member: {
          man: 0,
          woman: 0
        },
        visitors: {
          man: 0,
          woman: 0
        },
        children: {
          childrenMember10: 0,
          childrenMember15: 0,
          childrenMember20: 0,
          childrenMember30: 0,
          childrenMember40: 0,
          childrenMember50: 0,
          childrenVisitor10: 0,
          childrenVisitor15: 0,
          childrenVisitor20: 0,
          childrenVisitor30: 0,
          childrenVisitor40: 0,
          childrenVisitor50: 0
        },
        totalAmount: 0,
        roomAmount: 0,
        memberCount: 0,
        visitorCount: 0,
        childrenCount: 0
      },
      stayDays: 0, // number of days
      price: {},
      maxStayCapacity: null,
      minRoomStock: null,
      roomCapacity: 0,
      innerWidth: window.innerWidth
    }
  },
  mounted() {
    if (this.value) {
      this.dataBinding = JSON.parse(JSON.stringify(this.value))
    }
    this.minRoomStock = this.getMinRoomStock(this.stayDayDetails)
  },
  computed: {
    baseOnPrice() {
      return this.$store.getters.baseOnPrice
    },
    countMemberChildren() {
      const children =
        this.dataBinding && this.dataBinding.children ? this.dataBinding.children : null
      try {
        return (
          children.childrenMember10 +
          children.childrenMember15 +
          children.childrenMember20 +
          children.childrenMember30 +
          children.childrenMember40 +
          children.childrenMember50
        )
      } catch {
        return 0
      }
    },
    countVisitorChildren() {
      const children =
        this.dataBinding && this.dataBinding.children ? this.dataBinding.children : null
      try {
        return (
          children.childrenVisitor10 +
          children.childrenVisitor15 +
          children.childrenVisitor20 +
          children.childrenVisitor30 +
          children.childrenVisitor40 +
          children.childrenVisitor50
        )
      } catch {
        return 0
      }
    },

    getCustomerPlan() {
      return _.cloneDeep(_.get(this.$store.state, 'plan.customerPlan', null))
    },

    totalChild() {
      return this.countMemberChildren + this.countVisitorChildren
    },
    countPeopleSlots() {
      const children = _.get(this.dataBinding, 'children', null)
      const adultMemberSlot = this.dataBinding.member.man + this.dataBinding.member.woman
      const adultVisitorSlot =
        this.dataBinding.visitors.man + this.dataBinding.visitors.woman
      const memberSlots =
        children.childrenMember10 +
        children.childrenMember15 +
        children.childrenMember20 +
        children.childrenMember40
      const visitorSlots =
        children.childrenVisitor10 +
        children.childrenVisitor15 +
        children.childrenVisitor20 +
        children.childrenVisitor40
      return adultMemberSlot + adultVisitorSlot + memberSlots + visitorSlots
    },
    slotRemaining() {
      const slots = this.minRoomStock
      return slots - this.countPeopleSlots
    },
    memberAdultOptions() {
      // const memberAdults = this.getCustomerPlan.couponPlanData.memberAdults TODO
      const memberAdults = 19
      return this.getNumberOptions(memberAdults)
    },
    visitorAdultOptions() {
      // const visitorAdults = this.getCustomerPlan.couponPlanData.visitorAdults TODO
      const visitorAdults = 19
      return this.getNumberOptions(visitorAdults)
    },
    memberChildren10Options() {
      // const count = _.get(
      //   this.getCustomerPlan,
      //   'couponPlanData.memberChldDetails.childrenType10',
      //   0
      // )
      const count = 19
      return this.getNumberOptions(count)
    },
    memberChildren15Options() {
      // const count = _.get(
      //   this.getCustomerPlan,
      //   'couponPlanData.memberChldDetails.childrenType15',
      //   0
      // )
      const count = 19
      return this.getNumberOptions(count)
    },
    memberChildren20Options() {
      // const count = _.get(
      //   this.getCustomerPlan,
      //   'couponPlanData.memberChldDetails.childrenType20',
      //   0
      // )
      const count = 19
      return this.getNumberOptions(count)
    },
    memberChildren30Options() {
      // const count = _.get(
      //   this.getCustomerPlan,
      //   'couponPlanData.memberChldDetails.childrenType30',
      //   0
      // )
      const count = 19
      return this.getNumberOptions(count)
    },
    memberChildren40Options() {
      // const count = _.get(
      //   this.getCustomerPlan,
      //   'couponPlanData.memberChldDetails.childrenType40',
      //   0
      // )
      const count = 19
      return this.getNumberOptions(count)
    },
    memberChildren50Options() {
      // const count = _.get(
      //   this.getCustomerPlan,
      //   'couponPlanData.memberChldDetails.childrenType50',
      //   0
      // )
      const count = 19
      return this.getNumberOptions(count)
    },
    visitorChildren10Options() {
      // const count = _.get(
      //   this.getCustomerPlan,
      //   'couponPlanData.visitorChldDetails.childrenType10',
      //   0
      // )
      const count = 19
      return this.getNumberOptions(count)
    },
    visitorChildren15Options() {
      // const count = _.get(
      //   this.getCustomerPlan,
      //   'couponPlanData.visitorChldDetails.childrenType15',
      //   0
      // )
      const count = 19
      return this.getNumberOptions(count)
    },
    visitorChildren20Options() {
      // const count = _.get(
      //   this.getCustomerPlan,
      //   'couponPlanData.visitorChldDetails.childrenType20',
      //   0
      // )
      const count = 19
      return this.getNumberOptions(count)
    },
    visitorChildren30Options() {
      // const count = _.get(
      //   this.getCustomerPlan,
      //   'couponPlanData.visitorChldDetails.childrenType30',
      //   0
      // )
      const count = 19
      return this.getNumberOptions(count)
    },
    visitorChildren40Options() {
      // const count = _.get(
      //   this.getCustomerPlan,
      //   'couponPlanData.visitorChldDetails.childrenType40',
      //   0
      // )
      const count = 19
      return this.getNumberOptions(count)
    },
    visitorChildren50Options() {
      // const count = _.get(
      //   this.getCustomerPlan,
      //   'couponPlanData.visitorChldDetails.childrenType50',
      //   0
      // )
      const count = 19
      return this.getNumberOptions(count)
    }
  },
  watch: {
    dataBinding: {
      deep: true,
      handler(val) {
        this.$emit('input', val)
      }
    },
    totalChild(val) {
      this.dataBinding.childrenCount = val
    },
    roomAmount(val) {
      this.dataBinding.roomAmount = val
    }
  },
  methods: {
    onChangeTextInput($event, val) {
      const input = $event.target.value
      switch(val) {
      case 1: 
        this.dataBinding.member.manPrice = this.validateNumberHalfFullWidth(input)
        break
      case 2:
        this.dataBinding.children.childrenMember10Price = this.validateNumberHalfFullWidth(input)
        break
      case 3:
        this.dataBinding.children.childrenMember15Price = this.validateNumberHalfFullWidth(input)
        break
      case 4:
        this.dataBinding.visitors.visitorManPrice = this.validateNumberHalfFullWidth(input)
        break
      case 5:
        this.dataBinding.children.childrenVisitor10Price = this.validateNumberHalfFullWidth(input)
        break
      }
    },
    getPrice() {
      const detailDays = this.getCustomerPlan ? this.getCustomerPlan.detailDays : {}
      if (detailDays) {
        this.stayDays = detailDays.length
        const memberPrice =
          detailDays.map((item) => item.price).reduce((a, b) => a + b, 0) /
          detailDays.length
        const visitorPrice =
          detailDays.map((item) => item.adultPrice).reduce((a, b) => a + b, 0) /
          detailDays.length
        const childTypePrice = detailDays.map((item) => item.childTypePrice)
        const childrenType10 =
          childTypePrice.map((item) => item.childrenType10).reduce((a, b) => a + b, 0) /
          detailDays.length
        const childrenType15 =
          childTypePrice.map((item) => item.childrenType15).reduce((a, b) => a + b, 0) /
          detailDays.length
        const childrenType20 =
          childTypePrice.map((item) => item.childrenType20).reduce((a, b) => a + b, 0) /
          detailDays.length
        const childrenType30 =
          childTypePrice.map((item) => item.childrenType30).reduce((a, b) => a + b, 0) /
          detailDays.length
        const childrenType40 =
          childTypePrice.map((item) => item.childrenType40).reduce((a, b) => a + b, 0) /
          detailDays.length
        const childrenType50 =
          childTypePrice.map((item) => item.childrenType50).reduce((a, b) => a + b, 0) /
          detailDays.length
        const visitorType10 =
          childTypePrice.map((item) => item.visitorType10).reduce((a, b) => a + b, 0) /
          detailDays.length
        const visitorType15 =
          childTypePrice.map((item) => item.visitorType15).reduce((a, b) => a + b, 0) /
          detailDays.length
        const visitorType20 =
          childTypePrice.map((item) => item.visitorType20).reduce((a, b) => a + b, 0) /
          detailDays.length
        const visitorType30 =
          childTypePrice.map((item) => item.visitorType30).reduce((a, b) => a + b, 0) /
          detailDays.length
        const visitorType40 =
          childTypePrice.map((item) => item.visitorType40).reduce((a, b) => a + b, 0) /
          detailDays.length
        const visitorType50 =
          childTypePrice.map((item) => item.visitorType50).reduce((a, b) => a + b, 0) /
          detailDays.length
        const price = {
          roomPrice:
            this.dataBinding && this.dataBinding.roomPrice
              ? this.dataBinding.roomPrice
              : 0,
          visitor: visitorPrice,
          member: memberPrice,
          children: {
            childrenType10,
            childrenType15,
            childrenType20,
            childrenType30,
            childrenType40,
            childrenType50,
            visitorType10,
            visitorType15,
            visitorType20,
            visitorType30,
            visitorType40,
            visitorType50
          }
        }
        this.price = price
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'styles';

.table {
  &_head {
    background-color: #E7E6E7;
    @apply w-full p-2;
    th {
      @apply w-full p-2;
    }
  }
  &_item {
    @apply flex items-center justify-between gap-2 mb-2;
    > p {
      @apply w-full;
    }
    &__first {
      @apply pt-2;
    }
    &_select {
      text-indent: 0.01px;
      text-overflow: ellipsis;
      border: none;
      outline: none;
      background: transparent;
      background-image: none;
      box-shadow: none;
      -webkit-appearance: none;
      appearance: none;
      width: 100%;
      height: 100%;
      &::-ms-expand {
        display: none;
      }
      &_dummy {
        box-sizing: border-box;
        position: relative;
        overflow: hidden;
        outline: 1px solid #cacccf;
        border-radius: 4px;
        width: 140px;
        @apply py-1.5 px-1;
        &:has( > .table_item_select:focus) {
          outline: 2px solid #e60021;
        }
      }
    }
    &_cont {
      @apply flex items-center justify-end gap-2 w-full;
    }
    &_input {
      outline: 1px solid #cacccf;
      border-radius: 4px;
      width: 140px;
      &::placeholder {
        color: black;
      }
      &:focus {
        border: 2px solid #e60021 !important;
      }
      @apply py-1.5 px-1;
    }
  }
}
</style>
